import CustomLink from "./CustomLink";

const NavDropdown = ({ label, dropdownItems }) => {
  return (
    <li key={label}>
      <div className="dropdown pr-4 pl-3 w-full font-medium rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto inline-block">
        <button className="flex items-center rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 ">
          <span className="mr-1">{label}</span>
          <svg
            className="inline ml-1 w-5 h-5"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
        <ul className="dropdown-menu absolute right-3 md:right-auto hidden bg-gray text-gray-700 rounded-md border-solid border border-grey-200 shadow">
          {dropdownItems.map((item) => (
            <li key={item[0]} className="rounded-md">
              <CustomLink itemkey={item[0]} to={item[1]}>
                <span className="bg-white hover:bg-gray-200 hover:text-blue-700 py-2 px-4 block whitespace-no-wrap">
                  {item[0]}
                </span>
              </CustomLink>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default NavDropdown;
